// removed by extract-text-webpack-plugin
module.exports = {"inactive":"styles-module__inactive___3HGPr","active":"styles-module__active___2qdF0","icon":"styles-module__icon___3Q9Sx"};


//////////////////
// WEBPACK FOOTER
// ./src/core/components/SideBarButton/styles.module.css
// module id = 383
// module chunks = 0